module.exports = __webpack_public_path__ + "img/zw.c698f808.svg";